/**
 * UI default for the pending-response board's "Pending for at least N days"
 * filter (see design/actions.md § Pending-duration filter).
 *
 * One day normally, but three on Mondays: a review approved just before the
 * weekend has technically been "pending" all through Saturday and Sunday, yet
 * nobody was expected to act on it then. Requiring three days on a Monday
 * (Friday → Monday) keeps those from showing up as freshly overdue first thing
 * in the week.
 *
 * This is only the control's initial value — the manager can change it, and
 * the API's own default remains 0 (unfiltered) for programmatic callers. Pure
 * over its input (the caller passes `new Date().getDay()`, the viewer's local
 * weekday) so it is trivially testable.
 */
export function defaultPendingMinDays(dayOfWeek: number): number {
  const MONDAY = 1; // Date.getDay(): Sunday = 0, Monday = 1, …
  return dayOfWeek === MONDAY ? 3 : 1;
}
